import S3UploadHook from "./UploadToS3";

export async function handleUploadChange(e, setImageError, setImageLoading, givenHeight, givenWidth, givenSize, givenFileSize, typesAllowed, imageTypes, filePath, setTempImage, setImage, isAfterAction, nextFunction, id) {
    setImageError('');
    let isValid = true;
    if (Object.keys(e.target.files).length > 0) {
        setImageLoading(true)
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        if(givenHeight !== 0 && givenWidth !== 0) {
            reader.onload = function check(ev) {
                const img = new Image();
                img.src = ev.target.result;
                img.onload = function check1() {
                    const { height, width } = this;
                    if (height != givenHeight || width != givenWidth) {
                        setImageError(`File dimension should be ${givenWidth}x${givenHeight}`);
                        setImageLoading(false);
                        isValid = false;
                        setTimeout(() => {
                            e.target.value = ''
                        }, [2000]);
                        return
                    }
                };
            };
        }
        if(e.target.files[0].size > givenSize ){
            setImageError(`File size limit exceeded`);
            setImageLoading(false);
            isValid = false;
            setTimeout(() => {
                e.target.value = ''
            }, [2000]);
            return
        }
        if(!imageTypes.includes(e.target.files[0].type)){
            setImageError(`File format not supported`);
            setImageLoading(false);
            isValid = false;
            setTimeout(() => {
                e.target.value = ''
            }, [2000]);
            return
        }
        setTimeout(async () => {
            if(isValid === true) {
                const file = e.target.files[0]; 
                let url=''
                if(file.name && file.type){
                    url= await S3UploadHook(file, filePath, false);
                    setTempImage(url);
                    const val =`${filePath}/${file.name}`;
                    setImage(val);
                    e.target.value = ''
                    if(isAfterAction) {
                        nextFunction(val, id);
                    }
                    setImageLoading(false);
                }
            } 
        }, [2000]) ;
    }  
}
export const handleRemove = (setTempImage, setImage, setImageLoading, isAfterAction, nextFunction) =>{
    setTempImage('');
    setImage('');
    setImageLoading('');
    if(isAfterAction) {
        nextFunction('');
    }
}